export default __webpack_public_path__ + "static/media/dragons_bane.7437cf28.png";